import { action } from "satcheljs";
import type { SearchScenarioId } from "owa-search-store";

export interface ON_KEY_DOWN_SEARCH_INPUTActionMessage {
    evtKeyCode: number;
    scenarioId: SearchScenarioId;
}
export const onKeyDownSearchInput: (evtKeyCode: number, scenarioId: SearchScenarioId) => ON_KEY_DOWN_SEARCH_INPUTActionMessage = action("ON_KEY_DOWN_SEARCH_INPUT", (evtKeyCode: number, scenarioId: SearchScenarioId): ON_KEY_DOWN_SEARCH_INPUTActionMessage => ({
    evtKeyCode,
    scenarioId,
}));
